import { render, staticRenderFns } from "./TaskPlanningSetting.vue?vue&type=template&id=0d2c0a34&"
import script from "./TaskPlanningSetting.vue?vue&type=script&lang=js&"
export * from "./TaskPlanningSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports